import { GridOptions } from 'ag-grid-community'
import { useMemo } from 'react'
import {
  columnTypes,
  frameworkComponents,
} from '../../../containers/commons/AgGrid'
import { DEFAULT_COLUMN_DEF } from '../../../page-properties/bulksheet-properties'
import {
  PROGRAM_STATUSES,
  ProgramOverviewDto,
} from '../../../../infrastructure/api/programs'
import { useColumnDefs } from './columnDefs'

export const useProgramGridOptions = (): GridOptions<ProgramOverviewDto> => {
  const columnDefs = useColumnDefs()

  return useMemo(
    () => ({
      groupHeaderHeight: 25,
      headerHeight: 45,
      floatingFiltersHeight: 25,
      rowHeight: 32,
      treeData: false,
      context: {
        programStatuses: PROGRAM_STATUSES,
      },
      columnTypes: columnTypes(),
      components: frameworkComponents,
      defaultColGroupDef: { suppressHeaderContextMenu: true },
      defaultColDef: DEFAULT_COLUMN_DEF,
      columnDefs,
    }),
    [columnDefs]
  )
}
